import { Injectable } from "@angular/core";
import { NzMentionService } from "ng-zorro-antd/mention";

@Injectable()
export class UiMentionService extends NzMentionService {}
